// extracted by mini-css-extract-plugin
export default {"container":"SearchPatient_container__R5Bad","formItem":"SearchPatient_formItem__n9Qq5"};